import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import './i18n';
import './styles/global.css';

import { ConsentPage } from './pages/ConsentPage';
import { InvalidState } from './pages/states/InvalidState';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/consent/:token" element={<ConsentPage />} />
        <Route path="/" element={<Navigate to="/consent/missing" replace />} />
        <Route path="*" element={<InvalidState />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
